import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { Tag } from 'udesk-ui';
import { PointData } from 'src/api/types';

interface TemplateProps {
    inspectPoint?: PointData;
    isChosen?: boolean;
    onChoose?: (v: TemplateProps['inspectPoint']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { inspectPoint, isChosen, onChoose } = props;

    /**
     * 命中的逻辑：
     * 1.流程质检点：其子节点中有高亮配置命中信息
     * 2.其他质检点：见代码
     */
    const isHit = useMemo(() => {
        if (inspectPoint?.ruleType === Udesk.enums.ruleTypes.flow.id) {
            return inspectPoint?.canvasNodeMatchResultList?.some(
                (r) => !!r.highlightGroupList?.length
            );
        } else {
            return (
                inspectPoint?.gradeChooseHit === 1 ||
                (Boolean(inspectPoint?.pointHitValue) &&
                    parseFloat(inspectPoint?.pointHitValue!) !== 0) ||
                (Boolean(inspectPoint?.gradeInput) &&
                    parseFloat(inspectPoint?.gradeInput + '') !== 0)
            );
        }
    }, [inspectPoint]);

    /**
     * 得分展示的逻辑：
     * 1.流程质检点：finalScore
     * 2.其他质检点：predeterminedScore，但如果是 select 类型，根据选项值来展示
     */
    const score = useMemo(() => {
        if (inspectPoint?.ruleType === Udesk.enums.ruleTypes.flow.id) {
            return inspectPoint?.finalScore ?? '0';
        } else {
            let score = inspectPoint?.predeterminedScore ?? '0';

            if (inspectPoint?.gradeType === Udesk.enums.pointGradeTypes.select.id) {
                score =
                    inspectPoint?.gearOptionList?.find((o) => o.id === inspectPoint.pointHitValue)
                        ?.gradeChooseOption ?? '0';
            }

            return score;
        }
    }, [inspectPoint]);

    return (
        <Tag
            color={isHit ? 'rgb(139, 164, 248)' : 'rgba(139, 164, 248, 0.4)'}
            style={{
                boxShadow: isChosen ? '0px 0px 8px rgb(139, 164, 248)' : '',
                cursor: 'pointer',
            }}
            onClick={() => {
                isHit && onChoose?.(inspectPoint);
            }}
        >
            {inspectPoint?.name}
            {inspectPoint?.scoreType === 2 ? '-' : '+'}
            {score}分
        </Tag>
    );
});

export default Template;
